<div class="interview-setup-container">
  <!-- INTERVIEW DURATION -->
  <div class="section">
    <h3 class="section-title duration-title">
      <i class="bi bi-stopwatch-fill"></i> Interview Duration
    </h3>

    <div class="duration-grid">
      <div class="duration-card"
        *ngFor="let option of durationOptions"
        [class.selected]="selectedDuration === option.value"
		[class.disabled]="!isDurationAvailable(option.value)"
        (click)="onDurationClick(option.value)">
        <span *ngIf="selectedDuration === option.value" class="badge badge--crown">
          <i class="bi bi-suit-club"></i>
        </span>
        <span *ngIf="selectedDuration === option.value" class="badge badge--check">
          <i class="bi bi-check-lg"></i>
        </span>

        <div class="duration-time">{{ option.label }}</div>
        <div class="duration-desc">{{ option.description }}</div>
        <div *ngIf="option.premium" class="premium-text">Premium</div>
      </div>
    </div>
  </div>

  <!-- INTERVIEW LANGUAGE
  <div class="section">
    <h3 class="section-title language-title" style="color: var(--role-header);">
      <i class="bi bi-translate" style="color: var(--role-header);"></i> Preferred Language
    </h3>
    <p class="section-subtitle" style="font-size: 0.95rem; color: var(--paragraph-grey); margin-top: -0.6rem; margin-bottom: 1.2rem;">
      Select your comfortable speaking language. Evaluations and reporting will remain standardized in English.
    </p>

    <div class="language-grid">
      <div class="language-card"
        *ngFor="let lang of languages"
        [class.selected]="selectedLanguage === lang.code"
        (click)="selectLanguage(lang.code)">
        <span *ngIf="selectedLanguage === lang.code" class="badge--check">
          <i class="bi bi-check-lg"></i>
        </span>

        <div class="language-name" style="font-size: 1.2rem; font-weight: 700; color: var(--dark-black);">{{ lang.name }}</div>
        <div class="language-native" style="font-size: 0.9rem; color: var(--paragraph-grey); margin-top: 0.3rem;">{{ lang.native_name }}</div>
      </div>
    </div>
  </div>
  -->

  <!-- INTERVIEWER SELECTION -->
  <div class="section">
    <h3 class="section-title interviewer-title">
      <i class="bi bi-mic-fill"></i> Choose Your Interviewer
    </h3>

    <!-- Loading -->
    <div *ngIf="loading" class="loading-indicator">
      <i class="bi bi-arrow-repeat spin"></i> Loading interviewers...
    </div>

    <!-- Error -->
    <div *ngIf="!loading && errorMessage" class="error-message">
      <i class="bi bi-exclamation-triangle-fill"></i> {{ errorMessage }}
      <button class="retry-btn" (click)="loadInterviewers()">Retry</button>
    </div>

    <!-- Interviewers -->
    <div *ngIf="!loading && !errorMessage" class="interviewer-grid">
      <div class="interviewer-card"
        *ngFor="let interviewer of interviewers"
        [class.selected]="selectedInterviewer === interviewer.voice_id"
        (click)="selectInterviewer(interviewer)">
        <div class="interviewer-avatar">
          <img [src]="getInterviewerImage(interviewer.name)" [alt]="interviewer.name" />
        </div>
        <div class="interviewer-info">
          <p class="interviewer-name">{{ interviewer.name }}</p>
          <p class="interviewer-lang">{{ interviewer.accent }}</p>
          <!-- <small class="interviewer-desc">{{ interviewer.description }}</small> -->
        </div>
        <i class="bi bi-mic-fill status-icon"></i>
      </div>
    </div>
  </div>

  <!-- AUDIO / VIDEO REQUIREMENT -->
  <div class="notice-box">
    <i class="bi bi-exclamation-triangle-fill"></i>
    <div class="notice-content">
      <strong>Audio and video are required for this interview.</strong>
      <label class="checkbox">
        <input type="checkbox" [(ngModel)]="consent" />
        <span>
          I agree to use my camera and microphone during this session. This helps create a realistic interview
          experience and enables proper evaluation.
        </span>
      </label>
    </div>
  </div>

  <!-- ACTION BUTTONS -->
  <div class="action-buttons">
    <button class="back-btn" (click)="back.emit()">
      <i class="bi bi-arrow-left"></i> Back
    </button>

    <button class="continue-btn" [disabled]="!canContinue()" (click)="onContinue()">
      Continue →
    </button>
  </div>
</div>